import React from 'react';

// tabs: [{ value, label }], counts: { [value]: number }
export default function StatusTabs({ tabs, active, onChange, counts, total }) {
  return (
    <div className="status-tabs" role="tablist">
      {tabs.map((tab) => (
        <button
          key={tab.value}
          type="button"
          role="tab"
          aria-selected={active === tab.value}
          className={active === tab.value ? 'active' : ''}
          onClick={() => onChange(tab.value)}
        >
          {tab.label}
          <span>{tab.value === 'all' ? total : counts[tab.value] || 0}</span>
        </button>
      ))}
    </div>
  );
}
